<template>
  <div class="wrapper-form-input-paragrafo" :class="{ 'allow-markup-error': markupError }" :inert="!isPreenchimento">
    <p v-if="campo.tituloHtml && (isPreenchimento || pIsConferencia) && estilosPadrao" class="is-size-6 mb-2 titulo-campo-preenchivel" v-html="campo.tituloHtml"></p>
    <TrfToolbarTextEditorInline
      :id="guid"
      class="column py-0"
      :defaultText="formData.respostaTextoHtml ? formData.respostaTextoHtml : placeholder"
      @changeText="setValue"
      tag="p"
      :editorStyle="`.wrapper-form-input-paragrafo p.mce-content-body { width: 100%; background:#FFF; font-size: 1rem!important; color: #666!important; padding: .25rem .75rem; border-bottom: 1px solid #333333; transition: border 0.35s ease-in-out 0s} p.mce-content-body:focus-visible, p.mce-content-body:hover { outline: 0 none; border-bottom: 1px solid ${estilosPadrao.CorPrimaria}FF}`"
      :maxlength="5000"
      :toolbar-persist="isPreenchimento"
      :custom-toolbar="isPreenchimento"
      ref="inputParagrafo"
    ></TrfToolbarTextEditorInline>
    <p v-if="isInvalida" class="error-message">Campo obrigatório!</p>
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { stylesUtils } from '../../../util/styles.utils';
import { gerarGUID } from '../../../util/uuid.utils';
import CampoPersonalizado from '../models/campoPersonalizado.model';
export default {
  name: 'TrfCampoParagrafo',
  emits: ['update:value', 'set:validacao'],
  components: {
    TrfToolbarTextEditorInline: defineAsyncComponent(() => import('../../ToolbarTextEditor/inline.vue'))
  },
  props: {
    pCampo: {
      type: Object,
      default: new CampoPersonalizado()
    },
    pIsDirty: {
      type: Boolean,
      default: false
    },
    pSocioEmPreenchimento: {
      type: Object,
      default: () => {}
    },
    pIsConferencia: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Texto de resposta'
    },
    isPreenchimento: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      campo: this.pCampo,
      guid: gerarGUID(),
      estilosPadrao: '',
      formData: {
        respostaTexto: '',
        respostaTextoHtml: ''
      },
      isDirty: this.pIsDirty,
      campoIniciado: false
    };
  },
  computed: {
    isInvalida() {
      if (!this.required) return false;
      return this.isDirty && !this.formData.respostaTexto;
    },
    markupError() {
      return this.isPreenchimento && this.isInvalida;
    }
  },
  watch: {
    pIsDirty: {
      immediate: true,
      handler(novo) {
        this.isDirty = novo;
      }
    },
    isInvalida: {
      immediate: true,
      handler(novo) {
        if (this.required) {
          this.$emit('set:validacao', !novo);
        }
      }
    },
    pCampo: {
      immediate: true,
      handler(novo) {
        if (this.campoIniciado || !novo) return;

        let respostaDoCampo = null;

        if (novo.isCampoSocio && Array.isArray(novo?.respostasSocios)) {
          respostaDoCampo = novo.respostasSocios.find((resposta) => {
            return (
              (resposta.processoSocioId != null && resposta.processoSocioId == this.pSocioEmPreenchimento.socio.id) ||
              (resposta.uuid != null && resposta.uuid == this.pSocioEmPreenchimento.socio.uuid)
            );
          });
        }
        const respostaPreenchimentoTexto = respostaDoCampo ? respostaDoCampo.respostaTexto : this.pCampo.respostaTexto;
        const respostaPreenchimentoTextoHtml = respostaDoCampo ? respostaDoCampo.respostaTextoHtml : this.pCampo.respostaTextoHtml;
        this.formData.respostaTexto = respostaPreenchimentoTexto ? respostaPreenchimentoTexto : '';
        this.formData.respostaTextoHtml = respostaPreenchimentoTextoHtml ? respostaPreenchimentoTextoHtml : '';
        this.campoIniciado = true;
      }
    }
  },
  methods: {
    setValue(value) {
      if (value == this.formData.respostaTextoHtml || (this.formData.respostaTexto == '' && value.trim() == this.placeholder)) return;
      this.formData.respostaTextoHtml = value ? value : ''; //garante tipo
      this.formData.respostaTexto = this.$refs.inputParagrafo.getValueAsText();
      this.emitValue(this.formData);
      this.isDirty = true;
    },
    emitValue(value) {
      this.$emit('update:value', value);
    }
  },
  created() {
    this.estilosPadrao = stylesUtils.adquirirEstilosCookie();
  }
};
</script>
